<section class="active-jobs-modal">
  <header class="active-jobs-header">
    <div>
      <h2 id="active-jobs-title">Nudge creation history</h2>
      <p>{{ data.targetName }} · Current and recent creations</p>
    </div>
    <div class="jobs-header-actions">
      <button
        type="button"
        class="icon-button"
        aria-label="Refresh nudge creation history"
        [disabled]="historyLoading"
        (click)="loadJobHistory()"
      >
        <mat-icon>refresh</mat-icon>
      </button>
      <button
        type="button"
        class="icon-button"
        aria-label="Close nudge creation history"
        mat-dialog-close
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>
  <mat-dialog-content class="active-jobs-content">
    <p class="jobs-help" *ngIf="activeCount">
      Your nudges are being adapted. This can take several minutes; you can
      continue browsing.
    </p>
    <p class="jobs-discovery-message" role="status" *ngIf="historyLoading">
      Loading nudge creation history…
    </p>
    <p
      class="jobs-discovery-message history-error"
      role="status"
      *ngIf="historyError"
    >
      {{ historyError }}
      <button type="button" class="text-button" (click)="loadJobHistory()">
        Try again
      </button>
    </p>
    <section
      class="jobs-group"
      *ngFor="let group of modalJobGroups; trackBy: trackJobGroup"
    >
      <h3 class="jobs-group-title">
        {{ group.label }} <span>{{ group.jobs.length }}</span>
      </h3>
      <div class="adaptation-jobs">
        <section
          class="adaptation-job"
          *ngFor="let job of group.jobs; trackBy: trackJob"
          [class.job-attention]="
            job.status === 'error' ||
            job.failed ||
            job.needsReview ||
            job.monitorError
          "
        >
          <div class="adaptation-job-heading">
            <mat-icon aria-hidden="true">{{
              job.status === "running"
                ? "auto_awesome"
                : job.status === "canceling"
                  ? "hourglass_top"
                  : job.status === "canceled"
                    ? "cancel"
                    : job.status === "error" || job.failed || job.needsReview
                      ? "info"
                      : "check_circle"
            }}</mat-icon>
            <div class="adaptation-job-copy">
              <h4 role="status">{{ jobTitle(job) }}</h4>
              <p *ngIf="job.status !== 'running'">
                {{ job.nudges }} {{ job.nudges === 1 ? "nudge" : "nudges" }} ·
                {{ job.total }} adaptations
              </p>
              <p>
                Started by {{ job.startedBy?.name || job.startedBy?.email || job.startedBy?.userId || "Not recorded" }}
                <ng-container *ngIf="job.startedBy?.name && job.startedBy?.email">
                  · {{ job.startedBy?.email }}
                </ng-container>
              </p>
              <p *ngIf="job.createdAt">
                Started {{ job.createdAt | date: "short"
                }}<ng-container *ngIf="jobElapsed(job) as elapsed">
                  · {{ elapsed }}</ng-container
                >
              </p>
            </div>
            <span
              class="job-status"
              [class.job-status-attention]="job.status === 'error'"
              >{{
                job.status === "canceling" || job.cancelState
                  ? "Stopping…"
                  : job.status === "running"
                    ? "In progress"
                    : job.status === "error"
                      ? "Failed"
                      : job.status === "canceled"
                        ? "Canceled"
                        : "Completed"
              }}</span
            >
          </div>
          <div
            class="adaptation-progress"
            *ngIf="job.status === 'running' || job.status === 'canceling'"
          >
            <progress
              [value]="job.done"
              [max]="job.total || 1"
              [attr.aria-label]="'Adaptation progress for ' + job.targetName"
            ></progress>
            <span
              >{{ job.done }} / {{ job.total }} adaptations ·
              {{ jobProgress(job) | number: "1.0-0" }}%</span
            >
          </div>
          <div class="adaptation-counts" *ngIf="job.done || !isLive(job)">
            <span>{{ job.ready }} ready</span
            ><span>{{ job.needsReview }} need review</span
            ><span>{{ job.failed }} failed</span>
          </div>
          <p class="job-monitor-error" *ngIf="job.error">{{ job.error }}</p>
          <div class="job-stop-actions" *ngIf="isLive(job)">
            <button
              type="button"
              mat-stroked-button
              [disabled]="isStopping(job)"
              [attr.aria-label]="'Stop adaptation for ' + job.targetName"
              (click)="confirmStopJob(job)"
            >
              {{
                job.cancelState === "requesting"
                  ? "Requesting stop…"
                  : isStopping(job)
                    ? "Stopping…"
                    : "Stop job"
              }}
            </button>
            <p role="status">
              {{
                isStopping(job)
                  ? "Stopping. The nudges this run adapted are being removed."
                  : "Stopping discards this run — the nudges it has adapted so far are removed."
              }}
            </p>
          </div>
          <p class="job-monitor-error" role="alert" *ngIf="job.cancelError">
            {{ job.cancelError }}
          </p>
          <p *ngIf="job.status === 'canceled'">
            Stopped — the nudges this run adapted were removed.
          </p>
          <p class="job-monitor-error" role="status" *ngIf="job.monitorError">
            {{ job.monitorError }}
            <button
              *ngIf="job.pollingPaused"
              type="button"
              class="text-button"
              (click)="portService.retry(job)"
            >
              Check status again
            </button>
          </p>
          <div class="job-result-actions" *ngIf="job.status === 'completed' || canDeleteJob(job)">
            <button
              type="button"
              class="text-button job-results-button"
              *ngIf="job.status === 'completed'"
              [disabled]="jobResults[job.key]?.loading"
              [attr.aria-expanded]="!!jobResults[job.key]"
              (click)="toggleJobResults(job)"
            >
              {{ jobResults[job.key] ? "Hide results" : "View results" }}
            </button>
            <button
              *ngIf="canDeleteJob(job)"
              type="button"
              class="job-delete-button"
              [disabled]="!!deletePending || activeCount > 0"
              [attr.aria-label]="'Delete build for ' + job.targetName"
              (click)="confirmDeleteJob(job)"
            >
              <mat-icon aria-hidden="true">delete_outline</mat-icon>
              {{ deletePending === job.jobId ? 'Deleting…' : 'Delete build' }}
            </button>
          </div>
          <p class="job-delete-error" *ngIf="deleteError && deleteErrorJobId === job.jobId" role="alert">{{ deleteError }}</p>
          <div
            class="job-results"
            *ngIf="jobResults[job.key] as result"
            [attr.aria-busy]="result.loading"
          >
            <p role="status" *ngIf="result.loading">
              Loading results and fresh preview links…
            </p>
            <p role="status" *ngIf="result.error">
              {{ result.error }}
              <button
                type="button"
                class="text-button"
                (click)="loadJobResults(job)"
              >
                Try again
              </button>
            </p>
            <ng-container *ngIf="!result.loading && !result.error">
              <div class="job-preview-heading" *ngIf="result.links.length">
                <span>Live previews</span
                ><button
                  type="button"
                  class="text-button"
                  (click)="loadJobResults(job)"
                >
                  Refresh links
                </button>
              </div>
              <div class="job-preview-links">
                <a
                  *ngFor="let link of result.links"
                  [href]="link.previewUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  [attr.aria-label]="
                    'View ' + link.pageType + ' live (opens in a new tab)'
                  "
                  >{{ link.pageType }}
                  <mat-icon aria-hidden="true">open_in_new</mat-icon></a
                >
              </div>
              <p *ngIf="result.links.length">
                Links expire after about an hour. Refresh them to get new links.
              </p>
              <p *ngIf="!result.links.length">
                No nudges are ready to open yet. Retry any failed creations below.
              </p>
            </ng-container>
          </div>
          <p role="alert" *ngIf="retryError">{{ retryError }}</p>
          <!-- Per-nudge progress. Nudges finish one at a time, so a ready
                 one can be opened without waiting for the rest of the job. -->
          <div class="nudge-statuses" *ngIf="nudgeStatuses(job).length">
            <div
              class="nudge-status"
              *ngFor="let nudge of nudgeStatuses(job)"
              [class.nudge-status--ready]="nudge.status === 'ready'"
              [class.nudge-status--error]="nudge.status === 'error'"
            >
              <span class="nudge-status__dot" aria-hidden="true"></span>
              <span class="nudge-status__id">{{
                nudge.name || nudge.pageType || 'Nudge'
              }}</span>
              <span class="nudge-status__page">{{ nudge.pageType }}</span>
              <button type="button" class="text-button" *ngIf="job.status !== 'running' && nudge.status === 'error'"
                [disabled]="!!retryPending || activeCount > 0" (click)="retryNudge(job,nudge)"
                title="Rebuild this nudge in the same campaign, keeping its ID">
                {{ retryPending === job.jobId+':'+nudge.sourceIncentiveID ? 'Starting…' : 'Retry' }}
              </button>
              <span class="nudge-status__state">
                {{ nudgeStatusLabel(nudge) }}
              </span>
              <button
                type="button"
                class="text-button"
                *ngIf="canTestNudge(nudge)"
                [disabled]="testPending === nudge.sourceIncentiveID"
                (click)="testNudge(job, nudge)"
              >
                {{
                  testPending === nudge.sourceIncentiveID ? "Opening…" : "Open in editor"
                }}
              </button>
            </div>
          </div>

          <details class="adaptation-errors" *ngIf="job.errors.length">
            <summary>
              View {{ job.errors.length }}
              {{ job.errors.length === 1 ? "issue" : "issues" }}
            </summary>
            <ul>
              <li *ngFor="let issue of job.errors">
                <strong
                  >{{ issue.sourceIncentiveID }} · {{ issue.device }}</strong
                >
                <p>{{ issue.error }}</p>
              </li>
            </ul>
          </details>
        </section>
      </div>
    </section>
    <p
      class="jobs-empty"
      role="status"
      *ngIf="!historyLoading && !historyError && !modalJobs.length"
    >
      No jobs yet. Select nudges and create a library to get started.
    </p>
  </mat-dialog-content>
</section>
